
(() => {
  "use strict";

  const TIME_ZONE = "America/New_York";
  const CUTOFF_HOUR = 15; // 3 PM Eastern
  const MAX_PRODUCTION_DAYS = 60;

  // Annual studio closure: Dec 24 through Jan 3.
  // Jan 4 is the first eligible day, if it is a weekday.
  function isClosed(date) {
    const month = date.getUTCMonth() + 1;
    const day = date.getUTCDate();

    return (month === 12 && day >= 24) ||
           (month === 1 && day <= 3);
  }

  function isBusinessDay(date) {
    const day = date.getUTCDay();
    return day !== 0 && day !== 6 && !isClosed(date);
  }

  function getEasternNow() {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: TIME_ZONE,
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      hourCycle: "h23"
    }).formatToParts(new Date());

    const values = {};
    parts.forEach(part => {
      if (part.type !== "literal") {
        values[part.type] = Number(part.value);
      }
    });

    return values;
  }

  function calculateShipDate(days) {
    const now = getEasternNow();

    const date = new Date(Date.UTC(
      now.year,
      now.month - 1,
      now.day
    ));

    // Orders at or after 3 PM begin processing
    // from the next eligible business day.
    if (now.hour >= CUTOFF_HOUR || !isBusinessDay(date)) {
      do {
        date.setUTCDate(date.getUTCDate() + 1);
      } while (!isBusinessDay(date));
    }

    // Count full business days after processing begins.
    let counted = 0;

    while (counted < days) {
      date.setUTCDate(date.getUTCDate() + 1);

      if (isBusinessDay(date)) {
        counted++;
      }
    }

    return date;
  }

  function updateEstimates() {
    document.querySelectorAll(
      ".nm-shipping-estimate[data-production-days]"
    ).forEach(element => {
      const days = Number(element.dataset.productionDays);
      const text = element.querySelector(
        ".nm-shipping-estimate__text"
      );

      if (
        !text ||
        !Number.isInteger(days) ||
        days < 1 ||
        days > MAX_PRODUCTION_DAYS
      ) {
        element.hidden = true;
        return;
      }

      const shipDate = calculateShipDate(days);

      const formatted = new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        month: "long",
        day: "numeric",
        year: "numeric"
      }).format(shipDate);

      text.innerHTML = `Ships by: <strong>${formatted}</strong>`;
      element.hidden = false;
    });
  }

  function initialize() {
    updateEstimates();

    document.addEventListener(
      "shopify:section:load",
      updateEstimates
    );

    // Refresh when returning to a page left open.
    document.addEventListener(
      "visibilitychange",
      () => {
        if (!document.hidden) updateEstimates();
      }
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})();
